import React from "react";
import { Formik, Form, Field } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PopupMessage } from "../../utils/utils";
import { faChevronRight, faPlus, faTimes } from "@fortawesome/free-solid-svg-icons";
import CreatableSelect from "react-select/creatable";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "react-tabs/style/react-tabs.css";
import apiUrl from "../../apiUrlConstant";
import { Modal, Button } from "react-bootstrap";
import { Redirect, withRouter, Link } from "react-router-dom";
// import { PdfReader } from "../../utils/DocumentViewer";
import { ViewLeasePdfReader } from "../../utils/ViewLeaseDocumentViewer";
import SimpleReactValidator from "simple-react-validator";
import { leaseDateFormat } from "../../utils/utils";
import { fileUploadPath } from "../../utils/index";
var ReactS3Uploader = require("react-s3-uploader");
const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

var thisContext = {};
var formSubmitted = false;
class UploadDocument extends React.Component {
  state = {
    showLoader: false,
    redirect: false,
    showUploadDocument: false,
    fileName: "",
    documentType: "",
    popupContent: "",
    messsagePopup: false,
    fileSelected: false,
    uploadedDocuments: [],
    currentDocument: "",
    initialValues: {
      leaseDocumentType: "",
      leaseDocumentUrl: "",
      leaseUploadDocumentDate: "",
      leaseUploadDocumenURL: "",
      uploadDocType: "pdf",
    },
    pageNo: 1,
    documentTable: [],
    documentNames: [
      // "Commercial Approval Note",
      // "Expression of Intent",
      // "Letter of Intent",
      // "Term Sheet",
      // "Agreement to Lease",
      // "Agreement to License",
      // "Lease Deed",
      // "Leave and License Agreement",
      // "Atonement Deed"
    ],
    documentNamesAfterAdd: [],
    storageType: 's3',
    showUploadDocumentsError: false,
    fileError:''
  };

  constructor(props) {
    super(props);

    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });

    this.myInputRef = React.createRef();

    this.getInputValue = this.getInputValue.bind(this);

    thisContext = this;
  }

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  getInputValue() {
    const inputValue = this.myInputRef.current.value;

    console.log(inputValue, "===", this.myInputRef);
  }
  componentDidMount() {

    let athis=this;
    axios({
      url:`${apiUrl.apiUrl.url}/create-lease/fetch-document?id=${this.props.match.params.id}`,
      method: 'GET',
    }).then(function(response){
      let data = response.data;
      athis.setState({ documentNames: data.documentType });

      for (let i = 0; i < data.data.length; i++) {
        const index = athis.state.documentNames.indexOf(
          data.data[i].leaseDocumentType
        );
        if (index > -1) {
          //athis.state.documentNames.splice(index, 1);
        }
      }
      athis.state.documentTable = data.data;
      //console.log(athis.state.documentTable);
      let showFileUpload = false;
      if (data.leaseDocumentType != null) {
        showFileUpload = true;
      }
      athis.setState({
        initialValues: {
          leaseCreationDate: data.leaseCreationDate,
          leaseDocumentType: data.leaseDocumentType,
          leaseUploadDocumentDate: data.leaseUploadDocumentDate,
          leaseUploadDocumenURL: data.leaseUploadDocumenURL,
        },
        showUploadDocument: showFileUpload,
        storageType: data.additionalDetails.fileStorage
      });
    });

    // fetch(
    //   `${apiUrl.apiUrl.url}/create-lease/fetch-document?id=${this.props.match.params.id}`,
    //   { headers }
    // )
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((data) => {
    //     this.setState({ documentNames: data.documentType });

    //     for (let i = 0; i < data.data.length; i++) {
    //       const index = this.state.documentNames.indexOf(
    //         data.data[i].leaseDocumentType
    //       );
    //       if (index > -1) {
    //         //this.state.documentNames.splice(index, 1);
    //       }
    //     }
    //     this.state.documentTable = data.data;
    //     console.log(this.state.documentTable);
    //     let showFileUpload = false;
    //     if (data.leaseDocumentType != null) {
    //       showFileUpload = true;
    //     }
    //     this.setState({
    //       initialValues: {
    //         leaseCreationDate: data.leaseCreationDate,
    //         leaseDocumentType: data.leaseDocumentType,
    //         leaseUploadDocumentDate: data.leaseUploadDocumentDate,
    //         leaseUploadDocumenURL: data.leaseUploadDocumenURL,
    //       },
    //       showUploadDocument: showFileUpload,
    //       storageType: data.additionalDetails.fileStorage
    //     });
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }

  changeDocumentName(e) {
    var val = e.value; //e.target.value
    this.state.documentType = val;
    let timestamp = Date.now(); // Returns current timestamp in milliseconds
    const res = timestamp + "-" + val.replace(/ /g, "-").toLowerCase() + ".pdf";
    this.state.fileName = res;
    console.log(this.state.fileName, "FN");
    if (val !== "") {
      this.setState({
        showUploadDocument: true,
      });
    } else {
      this.setState({
        showUploadDocument: false,
      });
    }
  }

  uploadLocalFile = (e) => {
    e.preventDefault();

    // Allowed file extensions
    const allowedExtensions = ["pdf", "xls", "xlsx"];
    let extension = e.target.files[0].name.split('.').pop().toLowerCase();

    // Check if the extension is valid
    if (!allowedExtensions.includes(extension)) {
        this.setState({ fileError: "Invalid file type! Allowed: PDF, XLS, XLSX" });
        e.target.value = "";
        return;
    } else {
        this.setState({ fileError: "" });
    }

    const formData = new FormData();
    formData.append(
      'imageFile', e.target.files[0]
    );

    formData.append(
      'file_name', this.props.match.params.id + '_' + this.state.fileName
    );

    try {
      axios({
        method: "post",
        url: `${apiUrl.apiUrl.url}/upload-document/save`,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        thisContext.setState({
          fileSelected: true,
          showUploadDocumentsError: false
        });
      }).catch(function (error) {
        console.error('Error uploading file:', error);
      });

    } catch (error) {
      console.error('Error uploading file:', error);
    }
  }

  handleFileSelect = (event) => {
    if (event.target.files.length > 0) {

      const file = event.target.files[0];
      const allowedExtensions = ["pdf", "xls", "xlsx"];
      const extension = file.name.split('.').pop().toLowerCase();

      if(!allowedExtensions.includes(extension)){
        thisContext.setState({ fileError: "Invalid file type! Allowed: PDF, XLS, XLSX" });
        event.target.value = "";
        return;
      }

      thisContext.setState({
        fileSelected: true,
        showUploadDocumentsError: false
      });
    }
  };

  onUploadStart(file, next) {
    console.log(this, "on upload start", file, " === ", thisContext);
    thisContext.setState({ fileSelected: true, showLoader: true });
    thisContext.setState({});
    next(file);
  }

  onUploadError() {
    thisContext.setState({
      messsagePopup: true,
      popupContent: "Something Went Wrong!",
    });
    // alert("Something Went Wrong");
  }

  onUploadFinish = (e) => {
    console.log(this.state.initialValues, "intiali valuess before save");

    var values = {
      leaseDocument: {
        leaseDocumentType: this.state.initialValues.leaseDocumentType,
        leaseUploadDocumenURL: this.state.initialValues.leaseUploadDocumenURL,
        uploadDocType: this.state.initialValues.uploadDocType || "pdf",
        leaseUploadDocumentDate: this.state.initialValues.leaseUploadDocumentDate,
        leaseDocumentUrl: this.state.storageType == 's3' ? fileUploadPath() + this.props.match.params.id + "/" + this.state.fileName : this.props.match.params.id + '_' + this.state.fileName,
        storageType: this.state.storageType
      },
    };

    if (this.state.fileSelected === false) {
      values["leaseDocument"]["leaseDocumentUrl"] = "";
    }

    var self = this;
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/create-lease/upload-document?lease_id=${this.props.match.params.id}`,
      data: values,
    }).then(function (response) {
      console.log(response.data.data);
      self.state.fileSelected = false;
      if (!response.data.success) {
      } else {
        self.state.documentTable = response.data.data;
        formSubmitted = false;
        self.setState({});
      }
    });
    this.setState({
      messsagePopup: true,
      popupContent: "File Successfully Uploaded",
      showLoader: false,
    });
    // alert("File Successfully Uploaded");
  };

  handleUpload(e) {
    if (this.state.storageType == 's3') {
      this.uploader.uploadFile();
      setTimeout(function () {
        if (thisContext.state.fileSelected === false) {
          thisContext.onUploadFinish(e);
        } else {
          const index = thisContext.state.documentNames.indexOf(
            thisContext.state.initialValues.leaseDocumentType
          );
          if (index > -1) {
            thisContext.state.documentNames.splice(index, 1);
          }
          thisContext.state.showUploadDocument = false;
        }
        thisContext.setState({});
      }, 200);
    } else {
      thisContext.onUploadFinish(e);
      thisContext.setState({});
    }


  }
  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false, popupContent: "" });
  };
  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return (
        <Redirect
          push
          to={"/createlease/commercial-clauses/" + this.props.match.params.id}
        />
      );
    }
    return (
      <div
        className="parentContainer createLease"

      >
        <div>
          <div>
            <div className="absoluteItemForTopBar">
              <div className="new_breadcrumbs_design">
                <ul className="d-flex align-items-center gap-3 p-0 m-0">
                  <li>Create Lease</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>Critical Clause</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>
                    <a href="#">Upload Document</a>
                  </li>
                </ul>
              </div>
            </div>


            <Formik
              initialValues={this.state.initialValues}
              enableReinitialize
              onSubmit={(values, actions) => {

                this.formikProps = actions;

                if (!this.validator.allValid()) {
                  this.validator.showMessages();
                  return false;
                }
                values.leaseDocumentUrl =
                  fileUploadPath() +
                  this.props.match.params.id +
                  "/" +
                  this.state.fileName;
                console.log(values);
                var self = this;
              }}
            >
              {({
                values,

                errors,

                touched,

                handleChange,

                handleBlur,

                handleSubmit,

                isSubmitting,
              }) => (
                <>
                  <div className="unitFormContainerNew">
                    <Form autoComplete="off" >
                      <div className="newGridSectionParent">
                        <div className="newGridSectionForFormMain">
                          {this.state.showLoader && (
                            <div class="loading">
                              <div class="uil-ring-css">
                                <div></div>
                              </div>
                            </div>
                          )}
                          <div className="newGridSectionInner">
                            <label>
                              Document Name <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <CreatableSelect
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name={"leaseDocumentType"}
                                onChange={(e) => {
                                  this.state.initialValues.leaseDocumentType = e.value;
                                  this.changeDocumentName(e);
                                }}
                                value={{
                                  label: this.state.initialValues.leaseDocumentType,
                                  value: this.state.initialValues.leaseDocumentType,
                                }}
                                options={this.state.documentNames.map((item) => ({
                                  label: item,
                                  value: item,
                                }))}
                              />
                              {this.validator.message(
                                "Lease Document Name",
                                this.state.initialValues.leaseDocumentType,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>
                          <div className="newGridSectionInner">
                            <label>
                              Document Date <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                type="date"
                                name="leaseUploadDocumentDate"
                                value={this.state.initialValues.leaseUploadDocumentDate}
                                onChange={(e) => {
                                  this.state.initialValues.leaseUploadDocumentDate =
                                    e.target.value;
                                }}
                              />
                              {this.validator.message(
                                "lease Document Date",
                                this.state.initialValues.leaseUploadDocumentDate,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>
                          {this.state.showUploadDocument && (
                            <>
                              <div className="newGridSectionInner">
                                <label>
                                  Document Type <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <Field
                                    as="select"
                                    name={"uploadDocType"}
                                    onChange={(e) => {
                                      console.log(e.target.value, "e checking...");
                                      this.state.initialValues.uploadDocType = e.target.value;
                                      console.log(e.target.value, "checking xls or pdf");

                                      var filename = this.state.fileName;
                                      if (e.target.value === "pdf") {
                                        filename = filename.replace(/.pdf/g, "").toLowerCase();
                                        filename = filename.replace(/.xls/g, "").toLowerCase() + ".pdf";
                                      } else {
                                        filename = filename.replace(/.pdf/g, "").toLowerCase() + ".xls";
                                      }
                                      console.log(filename, "file name");
                                      this.setState({ fileName: filename });
                                      handleChange(e);
                                    }}
                                  >
                                    <option value="pdf" label="Pdf" />
                                    <option value="xls" label="Excel" />
                                  </Field>
                                </div>
                              </div>

                              <div className="newGridSectionInner">
                                <label>
                                  Upload Document <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  {this.state.storageType == 's3' ? (
                                    <ReactS3Uploader
                                      signingUrl={`/site/get-s3signed-url`}
                                      signingUrlMethod="GET"
                                      accept=".pdf, .xls, .xlsx"
                                      s3path={`${fileUploadPath()}${this.props.match.params.id}/`}
                                      preprocess={this.onUploadStart}
                                      onSignedUrl={this.onSignedUrl}
                                      onProgress={this.onUploadProgress}
                                      onError={this.onUploadError}
                                      onFinish={this.onUploadFinish}
                                      signingUrlWithCredentials={false}
                                      uploadRequestHeaders={{}}
                                      contentDisposition="attachment"
                                      scrubFilename={() => this.state.fileName}
                                      server={`${apiUrl.apiUrl.url}`}
                                      inputRef={(cmp) => {
                                        this.uploadInput = cmp;
                                        if (this.uploadInput) {
                                          this.uploadInput.addEventListener('change', this.handleFileSelect);
                                        }
                                      }}
                                      autoUpload={false}
                                      ref={(uploader) => {
                                        this.uploader = uploader;
                                      }}
                                    />
                                  ) : (
                                    <input
                                      type="file"
                                      accept=".pdf, .xls, .xlsx, .png"
                                      onChange={(e) => {
                                        this.uploadLocalFile(e);
                                      }}
                                    />
                                  )}
                                  {this.validator.message(
                                    "Document",
                                    this.state.fileName,
                                    "required",
                                    { className: "text-danger" }
                                  )}

                                  {this.state.fileError && (
                                      <p className="text-danger mt-1">{this.state.fileError}</p>
                                  )}
                                </div>
                              </div>

                              <div className="newGridSectionInner">
                                <label>
                                  Document URL <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <Field
                                    type="url"
                                    name="leaseUploadDocumenURL"
                                    value={this.state.initialValues.leaseUploadDocumenURL}
                                    onChange={(e) => {
                                      this.state.initialValues.leaseUploadDocumenURL = e.target.value;
                                      this.state.showUploadDocumentsError = false;
                                      handleChange(e);
                                      this.setState({});
                                    }}
                                  />
                                  {this.validator.message(
                                    "lease Document URL",
                                    this.state.initialValues.leaseUploadDocumenURL,
                                    "url",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            </>
                          )}
                          {this.state.showUploadDocumentsError && (
                            <div className="gridColOneByThree">
                              <label className="text-danger">Either provide document url or upload document</label>
                            </div>
                          )}
                        </div>
                        <div className="button_group mt-3 d-flex align-items-center gap-2 justify-content-end">
                          <button
                            className="add_button"
                            type="button"
                            onClick={(e) => {
                              if (
                                (typeof this.state.initialValues.leaseUploadDocumenURL === 'undefined' ||
                                  this.state.initialValues.leaseUploadDocumenURL === '') &&
                                this.state.fileSelected === false
                              ) {
                                this.setState({ showUploadDocumentsError: true });
                                return false;
                              }

                              if (!this.validator.allValid()) {
                                this.validator.showMessages();
                                return false;
                              }
                              if (!formSubmitted) {
                                this.handleUpload(e);
                                formSubmitted = true;
                              }
                            }}
                          >
                            Add
                          </button>
                          <button className="reset_button" type="button">
                            <Link to="/createlease">Cancel</Link>
                          </button>
                        </div>
                        <div className="tableContainer p-0">
                          <table className="table tableSimple">
                            <thead>
                              <tr>
                                <th scope="col">S.No</th>
                                <th scope="col">Document Name</th>
                                <th scope="col">Document Date</th>
                                <th scope="col">Storage Link</th>
                                <th scope="col" colSpan="">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.documentTable.map(function (
                                name,
                                index
                              ) {
                                return (
                                  <tr key={"cdocTable" + index}>
                                    <td>{index + 1}</td>
                                    <td>
                                      <a
                                        className="clauseNameLink"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          console.log(this.state.documentTable[index], "oowo")
                                          // let obj = this.state.documentTable.find(
                                          //   (o) =>
                                          //     o.leaseDocumentType ===
                                          //     name.leaseDocumentType
                                          // );
                                          let obj = this.state.documentTable[index];
                                          this.state.currentDocument = obj.url;
                                          console.log(obj.url, "obj.url");
                                          if (
                                            obj.url != "" &&
                                            obj.uploadDocType != "xls"
                                          ) {
                                            this.openModal();
                                          } else {
                                            window.location.href = obj.url;
                                          }
                                        }}
                                      >
                                        {name.leaseDocumentType}
                                      </a>
                                    </td>
                                    <td>
                                      {leaseDateFormat(
                                        name.leaseUploadDocumentDate
                                      )}
                                    </td>
                                    <td>
                                      {typeof name.leaseUploadDocumenURL !=
                                        "undefined" && (
                                          <a
                                            className="clauseNameLink"
                                            target="_blank"
                                            href={name.leaseUploadDocumenURL}
                                          >
                                            View
                                          </a>
                                        )}
                                    </td>
                                    <td>
                                      <button
                                        type="button"
                                        className="actionDelete rentalDeleteButton"
                                        onClick={(e) => {
                                          let values = {
                                            leaseDocumentType:
                                              name.leaseDocumentType,
                                              leaseDocumentUrl: name.leaseDocumentUrl
                                          };
                                          var self = this;
                                          axios({
                                            method: "post",
                                            url: `${apiUrl.apiUrl.url}/create-lease/delete-document?lease_id=${this.props.match.params.id}`,
                                            data: values,
                                          }).then(function (response) {
                                            console.log(response);
                                            if (!response.data.success) {
                                            } else {
                                              self.state.documentTable =
                                                response.data.data;
                                              self.state.documentNames.push(
                                                name.leaseDocumentType
                                              );
                                              self.setState({});
                                              self.setState({
                                                messsagePopup: true,
                                                popupContent:
                                                  "Data Deleted Successfully!",
                                              });
                                              // alert("Data Deleted Successfully");
                                            }
                                          });
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faTimes} />
                                      </button>
                                    </td>
                                  </tr>
                                );
                              },
                                this)}
                            </tbody>
                          </table>
                        </div>
                        <div className="row m-0">
                          <div className="col-lg-12">
                            <Modal
                              show={this.state.isOpen}
                              onHide={this.closeModal}
                              size="lg"
                              className="documentModal"
                            >
                              <Modal.Header closeButton>
                                <Modal.Title>
                                  <div className="container modalBreadCrumbs">
                                    <div className="row m-0">
                                      <div className="col-lg-12">
                                        <ul>
                                          <li>Document</li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <div className="container">
                                  <div className="row m-0">
                                    <ViewLeasePdfReader
                                      url={this.state.currentDocument}
                                      pageNumber={this.state.pageNo}
                                    />
                                  </div>
                                </div>
                              </Modal.Body>
                            </Modal>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                </>
              )}
            </Formik>
            <PopupMessage
              open={this.state.messsagePopup}
              content={this.state.popupContent}
              redirectAfterSave={this.redirectAfterSave}
            />
          </div >
        </div >
      </div >
    );
  }
}

export default withRouter(UploadDocument);
